/**
 * функция получения строки 5 лет, 2 года и т.д.
 * @param years количество лет
 */
export default function(years: number){
    years = Math.abs(years);
    if(11 <= years && years <=19)
        return years+ " лет";
    switch(years%10){            
        case 1: return years+" год";
        case 2: case 3: case 4:  return years+" года";

        //case 0: case 5: case 6: case 7: case 8: case 9: return years+" лет";
        default: return years + " лет";
    }
}

// import _Vue from "vue";

// const install = (Vue: typeof _Vue, url?: string) => {
  
//     const func = function(years: number){
//         years = Math.abs(years);
//         if(11 <= years && years <=19)
//             return years+ " лет";
//         switch(years%10){            
//             case 1: return years+" год";
//             case 2: case 3: case 4:  return years+" года";

//             //case 0: case 5: case 6: case 7: case 8: case 9: return years+" лет";
//             default: return years + " лет";
//         }
//     }

//   Vue.prototype.$getYearsString = func;
//   (Vue as any).$getYearsString = func;
// }
  
//   const plugin = {
//       install
//   }
  
//   export default plugin
